import { Printer } from 'lucide-react'
import "../../Styles/yellowcalfcss/ExpensesView.css"
import { FaPrint } from 'react-icons/fa'

const PaidBillView = () => {
  return (
   <>
<div className="expenses-view-bill-1-header-row">
  <h1 className="expenses-view-bill-1-page-title">Expense Details
</h1>

  <div className="expenses-view-bill-1-header-actions">
    
    <div className="expenses-view-bill-1-display-header-box">
      <span className="expenses-view-bill-1-header-label">
        Display Header
      </span>
      <input
        type="checkbox"
        defaultChecked
        className="expenses-view-bill-1-header-checkbox"
      />
    </div>

    <button
      className="expenses-view-bill-1-btn expenses-view-bill-1-btn-print"
      
    >
      Print <FaPrint  style={{ marginLeft: "5px" }} />
    </button>

    <button className="expenses-view-bill-1-btn expenses-view-bill-1-btn-edit">
      Edit
    </button>

    <button
      className="expenses-view-bill-1-btn expenses-view-bill-1-btn-delete"
    
    >
      Delete
    </button>

  </div>
</div>

<div className="expenses-view-bill-1-container">

  {/* Top Info Bar */}
  <div className="expenses-view-bill-1-info">
    <span><strong>Expense No:</strong> 1223</span>
    <span><strong>Account Type:</strong> test</span>
    <span><strong>Date:</strong> 11 Feb 2026</span>
  </div>

  {/* Table */}
  <table className="expenses-view-bill-1-table">
    <thead>
      <tr>
        <th>#</th>
        <th>Items</th>
        <th>Quantity</th>
        <th>Unit Price</th>
        <th>Item Total</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>1</td>
        <td>akbar</td>
        <td>1</td>
        <td>$ 4500</td>
        <td>$ 4500</td>
      </tr>

      {/* Total Row */}
      <tr className="expenses-view-bill-1-total-row">
        <td></td>
        <td></td>
        <td></td>
        <td className="total-label">Total Expense</td>
        <td className="total-value">$ 4500</td>
      </tr>
    </tbody>
  </table>

  {/* Print Button */}
  <div className="expenses-view-bill-1-print-box">
    <button className="expenses-view-bill-1-print-btn">
      Print 🖨
    </button>
  </div>

</div>
</>
  )
}

export default PaidBillView
